<template lang="html">

	<footer class="footer" :getLogged="getLogged" :class="$route.name == 'convocatoriaFpDualIntensiva' ? 'mt-0' : ''">
		<div class="topfooter" v-if="getLogged">
			<div class="container-logo">
				<img :src="brand.logo" alt="logo">
			</div>
			<div class="ul-links">
				<template v-if="isAlumno">
					<template>
						<router-link @click.native="hideMenu" :to="$t('enlaces.ofertas_practicas')" class="main"  :style="style.fontSecondary">{{
							$t('header.ofertas')
						}}</router-link>
					</template>
					
					<template
						v-if="showPropuestaPracticas && brand.siteEmpresa.showPropuestaPracticas && brand.siteAlumnos.showPropuestaPracticas && hasPracticas">
						<router-link class="main" :to="$t('enlaces.propuesta_practicas')"  :style="style.fontSecondary">{{
							$t('header.propuesta_practicas') }}</router-link>
					</template>
					<!-- <template v-if="!!ofertasParams.empleo.numTotal">
						<router-link @click.native="hideMenu" :style="style.fontSecondary"
							:to="$t('enlaces.ofertas_empleo')" class="main">{{ $t('header.oferta_empleo')
							}}</router-link>
					</template> -->
					<router-link v-if="isAlumno && brand.siteAlumnos.showMisCandidaturas" @click.native="hideMenu"
						:style="style.fontSecondary" :to="$t('enlaces.mis_candidaturas')" class="main" >{{
							$t('header.candidaturas')
						}}</router-link>
					<router-link @click.native="hideMenu" :style="style.fontSecondary" v-if="hasPracticas"
						:to="$t('enlaces.mis_practicas')" class="main">{{ $t('header.practicas') }}</router-link>

					<router-link v-if="isAlumno && brand.siteAlumnos.showMisEncuestas && encuestas.length > 0"
						@click.native="hideMenu" :style="style.fontSecondary" to="/#encuestas" class="main">
						{{ $t('header.encuestas') }}
					</router-link>
					<router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.cv')"
						class="main">{{
							$t('header.perfil') }}</router-link>

					<router-link v-if="brand.hasGuiasOrientacion" @click.native="hideMenu" :style="style.fontSecondary"
						:to="$t('enlaces.guiaOrientacion')" class="main">{{ $t('header.guias_orientacion')
						}}</router-link>
				</template>
				<template v-if="isEmpresa">
					<router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.mis_ofertas')"
						class="main">{{ $t('header.mis_ofertas') }}
					</router-link>

					<router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.nueva_oferta')"
						class="main">{{ $t('header.nueva_oferta') }}
					</router-link>

					<template
						v-if="showPropuestaPracticas && brand.siteEmpresa.showPropuestaPracticas && brand.siteAlumnos.showPropuestaPracticas">
						<span class="main" :style="style.fontSecondary"  v-if="brand.inactiveOfertasPracticas" :class="{'tooltip-disabled': brand.inactiveOfertasPracticas}" :text-tooltip="$t('header.proximamente')">{{ $t('header.propuesta_practicas') }}</span>
						<router-link v-else @click.native="hideMenu" class="main" :style="style.fontSecondary"
							:to="$t('enlaces.propuesta_practicas')">{{ $t('header.propuesta_practicas') }}</router-link>
					</template>

					<template v-if="brand.canCambiarPracticas">
						<router-link @click.native="hideMenu" class="main" :style="style.fontSecondary"
							:to="$t('enlaces.solicitarcambiopracticas')">{{ $t('header.solicitar_cambio_practicas')
							}}</router-link>
					</template>

					<template v-if="brand.hasProgramaPracticasActivo">
						<router-link @click.native="hideMenu" :style="style.fontSecondary"
							:to="$t('enlaces.programapracticasactivos')" class="main">{{ $t('header.programas') }}
						</router-link>
					</template>

					<span class="main" :style="style.fontSecondary"  v-if="brand.inactiveOfertasPracticas" :class="{'tooltip-disabled': brand.inactiveOfertasPracticas}" :text-tooltip="$t('header.proximamente')" >{{ $t('header.documentacion') }}</span>
					<router-link v-else @click.native="hideMenu" :style="style.fontSecondary" class="main"
						:to="$t('enlaces.documentacion')">{{
							$t('header.documentacion') }}
					</router-link>

					<template v-if="hasMenuEducacion && solicitudesEducacion.length != 0">
						<router-link @click.native="hideMenu" :style="style.fontSecondary" class="main"
							:to="$t('enlaces.practicaseducacion')">{{ $t('header.solicitudes_practicas_educacion') }}
						</router-link>
					</template>
					<router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.mi_perfil')"
						class="main">{{
							$t('encabezado.mi_perfil') }}
					</router-link>

					<router-link @click.native="hideMenu" :style="style.fontSecondary" :to="$t('enlaces.mi_empresa')"
						class="main">{{
							$t('header.mi_empresa') }}
					</router-link>

				</template>

			</div>
		</div>
		<div class="subfooter" :getLogged="getLogged">
			<div class="top row-center">
				<template v-for="t in texts" v-if="!!texts">
					<p v-html="t"></p>
				</template>
			</div>

			<nav class="bottom row-center" v-if="!!links">

				<template v-for="(data, key) in links">

					<a :href="data" target="_blank">{{ key }}</a>

				</template>

				<idioma v-if="brand.languagebydefault"></idioma>

			</nav>
			<a v-if="getLogged" class="btn" :href="'mailto:' + contactEmail">Contacta con nosotros</a>
		</div>
	</footer>

</template>

<script lang="js">

import { mapGetters } from 'vuex';


import idioma from '@/components/parts/idioma';

export default {
	name: 'app-footer',
	computed: {
		...mapGetters({
			colors: 'basicColors',
			texts: 'getFooterText',
			links: 'getFooterLinks',
			version: 'getVersion',
			brand: 'getBrand',
			getLogged: 'getLogged',
			isAlumno: 'isAlumno',
			isEmpresa: 'isEmpresa',
			style: 'getStyles',
			ofertasParams: 'getParamsOfertas',
			encuestas: "getEncuestas",
			hasPracticas: 'hasPracticas',
			brand: 'getBrand',
			hasMenuEducacion: 'getMenuEducacion',
			getShowPropuestaPracticas: 'getShowPropuestaPracticas'

		}),
		showPropuestaPracticas() {
			let show;

			if (typeof this.getShowPropuestaPracticas == 'string') {
				show = (this[this.getShowPropuestaPracticas]);
			} else {
				show = this.getShowPropuestaPracticas
			}

			return show;
		},
		ownstyles: function () {
			return {
				bgWhite: {
					background: this.colors.white
				}
			}
		},
		withoutMT: function () {
			let views = [
				'/login',
				'/login/empresas',
				'/login/antiguos',
				'/login/alumnos',
				'/mantenimiento',
				'/acceso',
				'/gma2019',
			];
			return (views.some(el => el == this.$route.path));
		},
		contactEmail() {
			if (this.isEmpresa && this.brand.emailContactoEmpresa) {
				return this.brand.emailContactoEmpresa;
			}
			return this.brand.emailContacto;
		}
	},
	components: {
		'idioma': idioma
	}
}
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// submodules/dotia-base-fp/src/components/parts/footer.vue